import React, { ReactNode } from 'react';
import Loading from "../../Loading";
import { useTranslation } from "react-i18next";

export const Button = ({ keyTitle, loading = false, icon = undefined, ...props }: React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> & { icon?: ReactNode, loading?: boolean, keyTitle: string }) => {
    
    const { t } = useTranslation()

    return (
        <button
            className={`${props.disabled && "opacity-40  !bg-gray-500"} tracking-wide text-center max-h-[48px] font-medium bg-main text-white gray-100 w-full py-4 px-8 rounded-md  transition-all duration-300 ease-in-out flex items-center justify-center focus:shadow-outline focus:outline-none`}
            {...props}
        >
            {
                icon && <span className={"mx-1"}>
                    {icon}
                </span>
            }
            <span>
                {loading ? <Loading /> : t(keyTitle)}
            </span>
        </button>
    );
};

